export default {
	OPERATOR_EQUALS: 'Uguale a',
	OPERATOR_NOT_EQUAL: 'Diverso da',
	OPERATOR_LIKE: 'Contiene',
	OPERATOR_NOT_LIKE: 'Non contiene',
	OPERATOR_GREATER: 'Maggiore',
	OPERATOR_GREATER_EQUAL: 'Maggiore o uguale',
	OPERATOR_SMALLER: 'Minore',
	OPERATOR_SMALLER_EQUAL: 'Minore o uguale',
	OPERATOR_RANGE: 'Compreso tra',
	OPERATOR_IN: 'Incluso in',
	OPERATOR_NOT_IN: 'Non incluso in',
	OPERATOR_IS_NULL: 'È vuoto',
	OPERATOR_IS_NOT_NULL: 'Non è vuoto',

	OPERATOR_BOOL_ALL: 'Tutti',
	OPERATOR_BOOL_TRUE: 'Vero',
	OPERATOR_BOOL_FALSE: 'Falso',

	QB_ADD_GROUP: 'Gruppo',
	QB_ADD_RULE: 'Regola',
	QB_DEL_GROUP: 'Rimuovi',
	QB_TEXT_SEPARATOR_AND: 'e'
};
